import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {

  transform(bytes: number): string {
    if (bytes === null || bytes === undefined || isNaN(bytes) || bytes < 0) {
      return '0 B';
    }

    if (bytes === 0) {
      return '0 B';
    }

    // Less than 1 KB
    if (bytes < 1024) {
      return `${bytes} B`;
    }

    // Less than 1 MB
    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${kb.toFixed(1)} KB`;
    }

    // Less than 1 GB
    const mb = kb / 1024;
    if (mb < 1024) {
      return `${mb.toFixed(1)} MB`;
    }

    // Less than 1 TB
    const gb = mb / 1024;
    if (gb < 1024) {
      return `${gb.toFixed(2)} GB`;
    }

    // 1 TB or more
    const tb = gb / 1024;
    return `${tb.toFixed(2)} TB`;
  }
}